/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the MapMarkerPropertiesDto interface.
 */
export function instanceOfMapMarkerPropertiesDto(value) {
    let isInstance = true;
    isInstance = isInstance && "cluster" in value;
    return isInstance;
}
export function MapMarkerPropertiesDtoFromJSON(json) {
    return MapMarkerPropertiesDtoFromJSONTyped(json, false);
}
export function MapMarkerPropertiesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cluster': json['cluster'],
        'pointCount': !exists(json, 'point_count') ? undefined : json['point_count'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'layerType': !exists(json, 'layerType') ? undefined : json['layerType'],
    };
}
export function MapMarkerPropertiesDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cluster': value.cluster,
        'point_count': value.pointCount,
        'id': value.id,
        'layerType': value.layerType,
    };
}
